export default function postHotfixReducer
  (state = { error:'', success:'', processing:false}, action)
{
  switch (action.type) {
    case 'POST_HOTFIX_SUCCESS':
      return {...state, ...{success: action.success}};

    case 'POST_HOTFIX_ERROR':
      return {...state, ...{error: action.error}};

    case 'POST_HOTFIX_PROCESSING':
      return {...state, ...{processing: action.processing}};

    default: return state;
  }
}